import React from "react";
import { PAGE_TITLE } from "@/common/constants/constants";
import browseJobByTitleDataFetch from "@/data/domain/browse-job-by-title.json";
import { v4 as uuidv4 } from "uuid";

import styles from "../../styles/BrowseBy.module.scss";
import Link from "next/link";

const BrowseByTitle = () => {
  return (
    <div className={styles.wrapper}>
      <h1>{PAGE_TITLE.BROWSE_BY_TITLE}</h1>
      <div className={styles.cardsWrapper}>
        {browseJobByTitleDataFetch.map((item) => {
          return (
            <Link
              href={{
                pathname: "/jobs",
                query: {
                  keyword: item.value,
                },
              }}
              key={uuidv4()}
            >
              <div className={styles.card}>{item.value}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BrowseByTitle;
